var _this = this;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import firebase from 'firebase/app';
import 'firebase/auth';
import { createToastInterface } from "vue-toastification";
var pluginOptions = {
  timeout: 4000
};
var TXT_SERVER_ERROR = '¡Ocurrió un error interno, intentelo en unos minutos!';
// DELETE y PATCH no se reenvían salvo ante 401/403 (token vencido): el backend pudo
// aplicar el cambio aunque responda error (409, 500, timeout del gateway) y reenviarlo
// lo repetiría. Se tratan como ya reintentados: muestran el error y rechazan.
var NO_RESEND_METHODS = ['delete', 'patch'];
var RESEND_STATUSES = [401, 403];
import tasks from '@/js/tasks';
var toast = createToastInterface(pluginOptions);
/*const promiseRefreshToken = new Promise((resolve, reject) => {
  console.log(firebase.auth())
  if (firebase.auth().currentUser) {
    console.log("get new token")
    firebase.auth().currentUser.getIdToken(true).then(() => {
      const userLogin = firebase.auth().currentUser
      if (!userLogin) {
        reject(new Error('No se pudo refrescar el token.'))
      }
      const userInfo = window.userInfo || {}
      // user info is global var
      window.userInfo = window.userInfo || {}
      userInfo['email'] = userLogin.email ? userLogin.email.toLowerCase() : userLogin.email
      userInfo['displayName'] = userLogin.displayName
      userInfo['userLogin'] = userLogin
      userInfo['accessToken'] = userLogin.xa || userLogin._lat || userLogin.ma
      userInfo['localId'] = userLogin.uid
      userInfo['loading'] = window.userInfo.loading
      userInfo['userRoles'] = window.userInfo.userRoles || null
      userInfo['listOrgs'] = window.userInfo.listOrgs || null
      resolve(window.userInfo)
    }).catch(() => {
      // on error try again
      reject(new Error('No se pudo refrescar el token.'));
    })
  } else {
    reject(new Error('No sesion active.'))
  }
});*/

var setup = function setup(axiosInstance) {
  axiosInstance.interceptors.request.use(function (config) {
    var token = window.userInfo.accessToken;
    if (token) {
      config.headers["Authorization"] = 'Bearer ' + token; // for Spring Boot back-end
      config.headers["Access-Control-Allow-Origin"] = '*';
      config.headers["Access-Control-Allow-Methods"] = "POST, GET, OPTIONS, DELETE";
      config.headers["Access-Control-Allow-Headers"] = "x-requested-with, authorization";
      // config.headers["x-access-token"] = token; // for Node.js Express back-end
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  });
  axiosInstance.interceptors.response.use(function (res) {
    return res;
  }, /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(err) {
      var originalConfig, method, retry, status, email, self, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            console.log(err);
            originalConfig = err.config;
            if (!(originalConfig && originalConfig.url !== "/security/user/login" && err.response)) {
              _context.n = 19;
              break;
            }
            method = (originalConfig.method || '').toLowerCase();
            if (NO_RESEND_METHODS.includes(method) && !RESEND_STATUSES.includes(err.response.status)) {
              originalConfig._retried = true;
            }
            retry = false;
            /*if (err.response.status === 500 && err.response.status === 400) {
              tasks.lockScreen.unlock()
              tasks.toast.error(TXT_SERVER_ERROR)
              return Promise.reject(err);
            }*/
            // `skipErrorToast`: la pantalla que hizo la llamada muestra el error en su propio
            // contexto (p. ej. dentro de un diálogo) y el aviso global lo taparía.
            if (!(err.response.status === 404 && originalConfig._retried)) {
              _context.n = 2;
              break;
            }
            tasks.lockScreen.unlock();
            //console.log(err.response.data.message)
            if (!originalConfig.skipErrorToast) {
              _context.n = 1;
              break;
            }
            return _context.a(2, Promise.reject(err));
          case 1:
            if (err.response && err.response.data && err.response.data.message) tasks.toast.error(err.response.data.message);else if (err.response && err.response.data && err.response.data.detail && err.response.data.detail.message) tasks.toast.error(err.response.data.detail.message);else tasks.toast.error(TXT_SERVER_ERROR);
            return _context.a(2, Promise.reject(err));
          case 2:
            if (err.response.status === 401 && originalConfig._retried) {
              tasks.lockScreen.unlock();
              console.log(err.response);
              if (err.response && err.response.message) if (err.response.message == 'Jwt is expired') {
                retry = true;
              }
            }
            // Access Token was expired
            if (!((err.response.status === 403 || retry) && !originalConfig._retried)) {
              _context.n = 9;
              break;
            }
            console.log("need to refresh token");
            originalConfig._retried = true;
            _context.p = 3;
            _context.n = 4;
            return firebase.auth().currentUser.getIdToken(true).then(function (idToken) {
              var userLogin = firebase.auth().currentUser;
              if (!userLogin) {
                return false;
              }
              var userInfo = window.userInfo || {};
              // user info is global var
              window.userInfo = window.userInfo || {};
              userInfo['email'] = userLogin.email ? userLogin.email.toLowerCase() : userLogin.email;
              userInfo['displayName'] = userLogin.displayName;
              userInfo['userLogin'] = userLogin;
              userInfo['accessToken'] = idToken;
              userInfo['localId'] = userLogin.uid;
              userInfo['loading'] = window.userInfo.loading;
              userInfo['userRoles'] = window.userInfo.userRoles || null;
              userInfo['listOrgs'] = window.userInfo.listOrgs || null;
              return true;
            }).catch(function () {
              // on error try again
              return false;
            });
          case 4:
            status = _context.v;
            if (!status) {
              _context.n = 5;
              break;
            }
            return _context.a(2, axiosInstance(originalConfig));
          case 5:
            return _context.a(2, Promise.reject(new Error("No se pudo obtener nuevo token.")));
          case 6:
            _context.n = 8;
            break;
          case 7:
            _context.p = 7;
            _t = _context.v;
            return _context.a(2, Promise.reject(_t));
          case 8:
            _context.n = 18;
            break;
          case 9:
            if (originalConfig._retried) {
              _context.n = 16;
              break;
            }
            originalConfig._retried = true;
            _context.p = 10;
            _context.n = 11;
            return firebase.auth().currentUser.getIdToken(true).then(function (idToken) {
              var userLogin = firebase.auth().currentUser;
              if (!userLogin) {
                return false;
              }
              var userInfo = window.userInfo || {};
              // user info is global var
              window.userInfo = window.userInfo || {};
              userInfo['email'] = userLogin.email ? userLogin.email.toLowerCase() : userLogin.email;
              userInfo['displayName'] = userLogin.displayName;
              userInfo['userLogin'] = userLogin;
              userInfo['accessToken'] = idToken;
              userInfo['localId'] = userLogin.uid;
              userInfo['loading'] = window.userInfo.loading;
              userInfo['userRoles'] = window.userInfo.userRoles || null;
              userInfo['listOrgs'] = window.userInfo.listOrgs || null;
              return true;
            }).catch(function () {
              // on error try again
              return false;
            });
          case 11:
            status = _context.v;
            if (!status) {
              _context.n = 12;
              break;
            }
            return _context.a(2, axiosInstance(originalConfig));
          case 12:
            return _context.a(2, Promise.reject(new Error("No se pudo obtener nuevo token.")));
          case 13:
            _context.n = 15;
            break;
          case 14:
            _context.p = 14;
            _t2 = _context.v;
            return _context.a(2, Promise.reject(_t2));
          case 15:
            _context.n = 18;
            break;
          case 16:
            tasks.lockScreen.unlock();
            if (!originalConfig.skipErrorToast) {
              _context.n = 17;
              break;
            }
            return _context.a(2, Promise.reject(err));
          case 17:
            if (err.response && err.response.data && err.response.data.message) tasks.toast.error(err.response.data.message);else if (err.response && err.response.data && err.response.data.detail && err.response.data.detail.message) tasks.toast.error(err.response.data.detail.message);else tasks.toast.error(TXT_SERVER_ERROR);
          case 18:
            _context.n = 20;
            break;
          case 19:
            // Sin `err.response` (red caída, timeout, CORS) o sin `err.config` (cancelación):
            // se rechaza con el error original, no con un TypeError de este interceptor.
            if (err.response && err.response.data) console.log(err.response.data.message);
            if (err.response && err.response.data && err.response.data.message) {
              if (err.response.data.message.indexOf('domain not allowed') != -1) {
                email = err.response.data.message.split("$");
                if (email.length > 1) {
                  email = email[1];
                }
                localStorage.clear();
                tasks.lockScreen.unlock();
                alert('El Dominio no se encuentra autorizado' + (email ? ' "' + email + '"' : '') + '. Vuelva a iniciar sesión con un correo corporativo.');
                self = _this;
                tasks.logoutApplication(function () {
                  console.log('callback: go to login');
                  //self.$router.push('/ContLogin')
                  location.reload();
                });
              }
            }
          case 20:
            return _context.a(2, Promise.reject(err));
        }
      }, _callee, null, [[10, 14], [3, 7]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
};
export default setup;